// src/UnarchiveIcon.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var UnarchiveIcon = ({ ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M17.4347 2.83331C17.567 3.04123 17.3404 3.28344 17.1001 3.22883C16.6301 3.08883 16.1101 3.01883 15.5801 3.01883H12.2798C12.1226 3.01883 11.9745 2.94488 11.8801 2.8192L10.7301 1.28883C10.5892 1.08927 10.7224 0.798828 10.9666 0.798828H13.7201C15.2811 0.798828 16.6561 1.60956 17.4347 2.83331Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M18.14 5.33883C17.71 5.02883 17.22 4.79883 16.69 4.66883C16.33 4.56883 15.96 4.51883 15.58 4.51883H11.86C11.28 4.51883 11.24 4.46883 10.93 4.05883L9.53 2.19883C8.88 1.32883 8.37 0.798828 6.74 0.798828H4.42C1.98 0.798828 0 2.77883 0 5.21883V16.3788C0 18.8188 1.98 20.7988 4.42 20.7988H15.58C18.02 20.7988 20 18.8188 20 16.3788V8.93883C20 7.44883 19.27 6.13883 18.14 5.33883Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M10.4305 6.73187L13.9235 10.2249C14.0457 10.3471 14.1027 10.5018 14.1027 10.6565C14.1027 10.8112 14.0457 10.9659 13.9235 11.088C13.6874 11.3242 13.2966 11.3242 13.0605 11.088L10.6096 8.63718L10.6096 16.9342C10.6096 17.2681 10.3328 17.5449 9.99893 17.5449C9.66509 17.5449 9.38825 17.2681 9.38825 16.9342L9.38825 8.63718L6.9374 11.088C6.70127 11.3242 6.31044 11.3242 6.07431 11.088C5.83818 10.8519 5.83818 10.4611 6.07431 10.2249L9.56739 6.73187C9.68138 6.61787 9.83608 6.55273 9.99893 6.55273C10.1618 6.55273 10.3165 6.61787 10.4305 6.73187Z",
          fill: "#6B7CE5"
        }
      )
    ]
  }
);
var UnarchiveIcon_default = UnarchiveIcon;

export {
  UnarchiveIcon_default
};
